import { render, staticRenderFns } from "./tableBrand.vue?vue&type=template&id=43e22d7e&scoped=true&"
import script from "./tableBrand.vue?vue&type=script&lang=js&"
export * from "./tableBrand.vue?vue&type=script&lang=js&"
import style0 from "./tableBrand.vue?vue&type=style&index=0&id=43e22d7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e22d7e",
  null
  
)

export default component.exports